import React from 'react'

const Facebook = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="32"
            height="30"
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M31.1267 12.8685C29.9324 2.15742 16.4629 -3.63994 7.2408 2.51095C3.48738 5.0119 0.973076 9.15668 0.227772 13.5578C-0.284065 16.5979 0.048177 19.8413 1.41308 22.6427C2.77801 25.4354 5.05876 27.7067 8.02212 28.7847C17.2262 32.152 29.7348 28.5196 31.1267 17.9147C31.3511 16.2444 31.3152 14.5387 31.1267 12.8685Z"
                fill="#534E46"
            />
            <path
                d="M13.2841 25.6035C13.2841 25.1439 13.6792 16.9073 13.2213 16.9161C12.476 16.9515 9.84492 16.9691 9.46771 16.925C9.08162 16.8808 8.90209 13.6198 9.24326 13.5049C9.59345 13.3899 13.2841 13.496 13.2841 13.496C13.2841 13.496 12.8172 9.13037 14.5951 7.31858C16.9029 4.9767 21.0156 6.13445 21.662 6.63817C21.7699 6.7177 21.7609 9.10386 21.5992 9.36009C21.5184 9.49265 19.6866 8.58238 18.1421 9.17451C16.436 9.82841 16.5347 11.9936 16.5706 13.4695C17.5673 13.4784 20.4318 13.4077 20.6205 13.6285C20.7461 13.7789 20.8809 16.4566 20.4139 16.81C20.0726 17.0664 16.5168 16.8278 16.5078 16.9869C16.4091 19.9474 16.5617 25.1439 16.5617 25.6122C16.5796 26.0718 13.2841 26.0629 13.2841 25.6035Z"
                fill="white"
            />
        </svg>
    )
}

export default Facebook
